window.addEventListener('DOMContentLoaded', () => {
  $('.shopify-section-header-sticky').css('position', 'unset');
  let jq_object = $('.nav_container');
  const navOffset = jq_object.offset();
  if (!jq_object.length || !navOffset) return;

  let target = navOffset.top;

  // 获取所有 section 的 offset
  let sections = $('.section');

  const targetsTop = [];
  $('.nav_list .nav_item').each(function () {
    const selector = $(this).attr('href');
    if (!selector || typeof selector !== 'string') return;
    const $target = $(selector);
    const off = $target.length ? $target.offset() : null;
    if (!off) return;
    targetsTop.push({ selector, top: off.top - 100 });
  });

  $(window).scroll(function () {
      let scrollTop = $(window).scrollTop();
      
      // 固定导航条
      if (scrollTop > target) {
          $(jq_object).addClass('fix_top');
      } else {
          $(jq_object).removeClass('fix_top');
      }

      if (scrollTop > target) {
          targetsTop.forEach((item, index) => {
              const nextTop = targetsTop[index + 1]?.top ?? Infinity;

              if (scrollTop >= item.top && scrollTop < nextTop) {
                  $('.nav_list .nav_item').removeClass('active');
                  $(`.nav_list .nav_item[href="${item.selector}"]`).addClass('active');
              }
          });
      } else {
          $('.nav_list .nav_item').removeClass('active');
      }

      // 检查当前滚动位置并添加 active 类
    //   sections.each(function() {
    //       let sectionOffset = $(this).offset().top - 80; 
    //       let sectionHeight = $(this).outerHeight();

    //       if (scrollTop >= sectionOffset && scrollTop < sectionOffset + sectionHeight) {
    //           let id = $(this).attr('id');
    //           $('.nav_item').removeClass('active'); 
    //           $('.nav_item[href="#' + id + '"]').addClass('active');
    //       }
    //   });
  });

  $('.nav_list .nav_item').on('click', function (e) {
      e.stopPropagation();
      let sectionid = $(this).attr('href');
      if (!sectionid) return;
      const $section = $(sectionid);
      const off = $section.length ? $section.offset() : null;
      if (!off) return;
      let scrollHeight = off.top - 80;
      $('html,body').animate({ scrollTop: scrollHeight }, 300);
  });
});
